var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { main_routes } from "./routes/main_routes";
import './assets/scss/form_styles.scss';
import { ThemeProvider } from "@mui/material";
import { defaultTheme } from "./Themes/default_theme";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Loader from "./components/loader";
import ChunkErrorBoundary from "./components/ChunkErrorBoundary";
import SnackBarAlert from "./utils/SnackBarAlert";
import AlertPopupContainer from "./components/UtilityComponents/AlertPopupContainer";
import 'moment-timezone';
import TagManager from 'react-gtm-module';
import { I18nextProvider } from "react-i18next";
import i18n from "./config/translations/i18n";
import { useDispatch, useSelector } from "react-redux";
import { app_actions } from "./actions/app_actions";
import { loginSignup_asyncActions } from "./asyncActions/loginSignup_asynActions";
import useSessionSync from "./pages/loginSignup/useSessionSync";
import useImpersonationSessionGuard from "./pages/loginSignup/useImpersonationSessionGuard";
import BuildVersionMismatch from "./components/buildVersionMismatch";
import { getContrastText } from "./utils/commonUtilities";
try {
    const navEntry = performance.getEntriesByType('navigation')[0];
    if ((navEntry === null || navEntry === void 0 ? void 0 : navEntry.type) === 'reload' && ((_a = window.history.state) === null || _a === void 0 ? void 0 : _a.usr)) {
        const _b = window.history.state.usr, { globalSearchText, selectedResult, dashboardSelectedResult } = _b, restUsr = __rest(_b, ["globalSearchText", "selectedResult", "dashboardSelectedResult"]);
        const cleanUsr = Object.keys(restUsr).length > 0 ? restUsr : null;
        window.history.replaceState(Object.assign(Object.assign({}, window.history.state), { usr: cleanUsr }), '');
    }
}
catch (_c) {
}
const router = createBrowserRouter(main_routes);
const App = (props) => {
    const vendorConfig = useSelector((state) => state.vendor.vendorDetails);
    const dispatch = useDispatch();
    const themeDef = defaultTheme();
    const tagManagerArgs = {
        gtmId: 'GTM-K96TL9LK',
    };
    TagManager.initialize(tagManagerArgs);
    useSessionSync();
    useImpersonationSessionGuard();
    const fetchVendorConfigData = () => {
        dispatch(loginSignup_asyncActions.getVendorConfigDetails())
            .then((response) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                document.title = (_d = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.DealerName) !== null && _d !== void 0 ? _d : "PowerTech Finance";
                const root = document.documentElement;
                root.style.setProperty('--color', (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.PrimaryThemeColor);
                root.style.setProperty('--color-contrast-text', getContrastText((_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.PrimaryThemeColor));
                root.style.setProperty('--font-family', (_k = (_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.FontStyle);
                dispatch(app_actions.vendorConfigDetails({ vendor_config_details: response.data.data }));
            }
            else {
            }
        }).catch((error) => {
        });
    };
    React.useEffect(() => {
        fetchVendorConfigData();
    }, []);
    return (React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(ThemeProvider, { theme: themeDef },
            React.createElement(SnackBarAlert, null),
            React.createElement(AlertPopupContainer, null),
            React.createElement(Loader, null),
            React.createElement(BuildVersionMismatch, null),
            React.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
                React.createElement(ChunkErrorBoundary, null,
                    React.createElement(React.Suspense, { fallback: null },
                        React.createElement(RouterProvider, { router: router })))))));
};
export default App;
